/*!
 * commonly used JS
 *
 * Copyright 2014-current IDD
 *
 * var OP: GEEN ES6+ FEATURES GEBRUIKEN
 *
 */
!(function(root, factory) {
	if (typeof define === "function" && define.amd) {
		define("idd/common", [], factory);
	} else {
		
		var common = factory();
		if (common === false) return;
		
		root.IDD = common;
		root.idd_uriRoot          = root.IDD.uriRoot
		root.idd_origin           = root.IDD.origin;
		root.idd_assert           = root.IDD.assert;
		root.idd_escapeHTML       = root.IDD.escapeHTML;
		root.JSON_stringify       = root.IDD.jsonStringify
		root.idd_isidd            = root.IDD.isidd;
		root.idd_addEvent         = root.IDD.addEvent;
		root.idd_print_r          = root.IDD.printR;
		root.idd_time             = root.IDD.time;
		root.idd_timeEnd          = root.IDD.timeEnd
		root.idd_alert            = root.IDD.alertBox;
		root.idd_htmlEntityDecode = root.IDD.htmlEntityDecode;
		root.idd_autoresizeTextareas = root.IDD.autoresizeTextareas;
		root.idd_resizeTextarea      = root.IDD.resizeTextarea;
		root.idd_killUserPassAutocomplete = root.IDD.killUserPassAutocomplete;
		root.idd_formChangedLeavePageWarning = root.IDD.formChangedLeavePageWarning;
		root.idd_formChangedWindowOnBeforeUnload = root.IDD.idd_formChangedWindowOnBeforeUnload;
		root.idd_formChangedReturnMessage = root.IDD.idd_formChangedReturnMessage;
		root.idd_makePasswordToggle = root.IDD.makePasswordToggle;
		root.idd_debugHideShow = root.IDD.debugHideShow;
		root.idd_disableSiblingNullLabel = root.IDD.disableSiblingNullLabel;
		root.idd_prevent_enter_submit = root.IDD.prevent_enter_submit;
	}
})(this, function() {

	//voorkom twee keer runnen, geen idee of AMD dit al doet maar ik zie steeds alle events dubbel
	//doordat common.js twee keer included wordt (servicelink)
	if (typeof window.idd_common !== 'undefined') return false;
	window.idd_common = 'defined';
	
	
	//voeg browsercompatible events toe aan element voor als je jquery niet gebruikt ergens
	// gebruiken in plaats van 'onclick=' want dan kan je maar 1 event ergens aan hangen.
	//
	// element    - element waar je iets aan wil hangen
	// eventType  - 'click', 'load', etc, de 'on[iets]' zonder de 'on'
	// callback   - de functie die wordt aangeroepen
	// useCapture - zie https://developer.mozilla.org/en/DOM/element.addEventListener en
	//                  http://www.w3.org/TR/DOM-Level-3-Events/#event-flow
	//
	function idd_addEvent(element, eventType, callback, useCapture) {
		
		//default value
		if (useCapture === undefined ) useCapture = false;
		
		//wereld
		element.addEventListener(eventType, callback, useCapture);
		return true;
	} 
	
	
	function idd_makePasswordToggle() {
		// Zoek alle wachtwoordvelden op de pagina.
		var passwordInputs = document.body.querySelectorAll('input[type="password"]');
		var inputCount = passwordInputs.length;
		
		for (var i = 0; i < inputCount; i++) {
			var passwordInput = passwordInputs[i];
			
			// Het zou kunnen dat deze functie voor de tweede keer wordt aangeroepen:
			// skip deze input als we hem al hebben gehad.
			if (passwordInput.classList.contains('PasswordShowToggle')) continue;
			
			// Voeg een class toe aan de input zodat we hem makkelijk kunnen aanroepen op vinden.
			passwordInput.classList.add('PasswordShowToggle');
			
			// We maken een span met relative position om het knopje goed te kunnen positioneren.
			var span = document.createElement('span');
			span.style.cssText = 'position:relative; display:inline-flex; box-sizing:border-box;';
			
			// We maken het icoon en zetten hem op de goede plek binnenin de input.
			var img = new Image();
			img.src = '/icons/eye_open_icon.svg';
			img.style.cssText = "position: absolute;"+
			                    "top: 50%;"+
			                    "transform: translateY(-50%);"+
			                    "right: .2em;"+
			                    "width: auto;"+
			                    "height: 25px;"+
			                    "max-height: 30px;"+
			                    "cursor: pointer;";
			
			// Vervang de input door de span...
			passwordInput.parentNode.replaceChild(span, passwordInput);
			// ...en zet de input er weer onder, samen met het oog-icoon. appendChild kan niet in IE.
			span.appendChild(passwordInput);
			span.appendChild(img);
			
			img.addEventListener('click', function() {
				// Zoek het oogje ('this') en de input (sibling van 'this').
				var passwordInput = this.previousSibling;
				var img = this;
				
				// Voorkomt snellere timeout bij tweede toggle binnen vijf seconden door dubbele aanroep van setTimeout().
				if (this.timeoutID) {
					clearTimeout(this.timeoutID);
				}
				
				// Toggle input-type en oog-icoontje.
				if (passwordInput.type == 'password') {
					passwordInput.type = 'text';
					img.src = '/icons/eye_closed_icon.svg';
					// Na vijf seconden weer onzichtbaar maken.
					this.timeoutID = setTimeout(function() {
						passwordInput.type = 'password';
						img.src = '/icons/eye_open_icon.svg';
					}, 1500);
				} else {
					passwordInput.type = 'password';
					img.src = '/icons/eye_open_icon.svg';
				}
				
			});
			
			// Het wachtwoord wordt ook weer onzichtbaar gemaakt als je op de input klikt, kan nu ook niet gekopieerd worden!
			passwordInput.addEventListener('click', function() {
				if (this.type == 'text') {
					this.type = 'password';
					this.nextSibling.src = '/icons/eye_open_icon.svg';
				}
			});
		}
	}
	
	
	// Voor het in en uitklappen van idd_debug boxjes
	function idd_debugHideShow() {
		document.querySelectorAll(".idd_debug").forEach(function(iddDebug) {
			var iddDebugHideThis = iddDebug.querySelector(".idd_debug-hide-this");
			var iddDebugHideAll  = iddDebug.querySelector(".idd_debug-hide-all");
			var iddDebugContent  = iddDebug.querySelector(".idd_debug-content");
			
			if (iddDebugHideThis !== null) {
				iddDebugHideThis.addEventListener('click', function() {
					iddDebugContent.style.display = iddDebugContent.style.display === "none" ? "block" : "none";
				});
			}
			
			if (iddDebugHideAll !== null) {
				iddDebugHideAll.addEventListener('click', function() {
					var iddDebugIsHidden = iddDebugContent.style.display === "none";
					document.querySelectorAll(".idd_debug-content").forEach(function(iddDebugContent) {
						iddDebugContent.style.display = iddDebugIsHidden ? "block" : "none";
					});
				});
			}
			
			//auto hide $_POST en $_SESSION en $_COOKIE
			var title = iddDebug.querySelector(".idd_debug-title");
			if (title !== null) {
				if (title.innerText.startsWith("$_")) {
					var reqMethod = document.querySelector('meta[name="request-method"]');
					if ((reqMethod !== null && reqMethod.content != 'POST') || !title.innerText.startsWith('$_POST')) {
						iddDebugHideThis.click();
					}
				}
			}
		});
	}
		
	
	// idd-prevent-enter-submit houd het submitten van forms via enter tegen
	function idd_prevent_enter_submit() {
		var forms = document.querySelectorAll("form.idd-prevent-enter-submit");
		forms.forEach(function(form) {
			idd_addEvent(form, 'keypress', function (e) {
				// enter in textarea moet nog wel mogelijk zijn.
				if (e.keyCode == 13 && e.target.tagName != 'TEXTAREA') {
					e.preventDefault();
					return false;
				}
			});
		});
	}
	
	
	//a la idd_uriRoot in common_functions, met iidesk uitzondering. doet niet checken of domein geldig is want kan
	// niet in .js.
	function idd_uriRoot() {
		var uri = idd_origin();
		var isIIdesk = uri.match('iidesk.') != null;
		
		if (isIIdesk) {
			uri += window.location.pathname.slice(0,window.location.pathname.indexOf('/',1)+1);
		} else {
			uri += "/";
		}
		return uri;
	}
	
	
	// Returns the base url of the current page (protocol + host)
	// Needed because window.location.origin is only supported in IE11 or up.
	// IN:
	//UIT: string
	function idd_origin() {
		if ( !window.location.origin ) {
			return window.location.protocol + '//' + window.location.host;
		}
		
		return window.location.origin;
	}
	
	
	// idd_assert controleert feitelijk of je true of false meegeeft. Indien je false meegeeft
	// dan wordt een error gelogd in de browser z'n JavaScript Console. Je kan dit gebruiken als sanity checks voor
	// dingen die altijd waar moeten zijn.
	//
	//  IN: exp     - boolean
	//      message - mogelijk commentaar voor in de JavaScript Console log.
	// UIT: waarde die exp oplevert of de boolean die je meegaf.
	function idd_assert(exp, message) {
		
		if ( typeof exp !== 'boolean') {
			throw new Error("Given expression is not a boolean type.");
		}
		
		if ( !exp ) {
			message = typeof(message) !== 'undefined' ? message : 'Unexpected error occurred.';
			
			throw new Error("Assertion: - " + message + " - failed in...");
		}
		
		return exp;
	}
	
	
	// Use the browser's built-in functionality to quickly and safely escape the input string.
	function idd_escapeHTML(string) {
		var div = document.createElement('div');
		div.appendChild(document.createTextNode(string));
		
		return div.innerHTML;
	}
	
	
	// unescape HTML
	// http://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript
	// IN: string
	//UIT: unescaped string
	function idd_htmlEntityDecode(string) {
		var doc = new DOMParser().parseFromString(string, "text/html");
		return doc.documentElement.textContent;
	}
	
	
	//om makkelijk te kunnen bepalen of we idd zijn; in javascript niet voor de hand liggend; een lijst
	// met IP adressen is veel te gevoelig.
	//
	// poog te kijken naar de url, als daar geen www. voor staat is het waarschijnlijk een zandbak
	//
	//  IN: -
	// UIT: true/false
	function idd_isidd() {
		var hier = location.href;
		
		// vrijwel al onze sites hebben hoogstens twee punten in de naam
		// www.iidesk.com, iidesk.com
		// alleen ii.nl is uitzondering: i.ii.nl etc.
		// als het dan jasper.i.ii.nl is dan is het debug
		var iinl = /https?:\/\/([^.]+\.)?([^.]+\.)?ii\.nl\//gi;
		var tweepunt = /https?:\/\/([^.]+)\.[^.]+\.(com|nl)\//gi;
		var driepunt = /https?:\/\/([^.]+)\.[^.]+\.[^.]+\.(com|nl)\//gi;
		var match;
		
		//is het de uitzondering
		if (null !== (match = iinl.exec(hier))) {
			if (null !== (match = driepunt.exec(hier))) {
				return match[1] != 'www';
			}
		}
		
		//dan alleen xxx.iidesk.com accepteren als
		if (null !== (match = tweepunt.exec(hier))) {
			return match[1] != 'www';
		}
		
		//de rest (eenpunt)
		return false;
		
	}
	
	
	// Detecteert of dit idd is en of er wel een console is om naar te loggen, zodat de pagina
	// niet vastloopt als er geen console open is maar wel wordt gelogd.
	function idd_print_r(message,name) {
		if (!idd_isidd()) return;
		
		if (window.console && console.log !== undefined) {
			if (name === undefined) {
				return console.log(message);
			} else {
				return console.log(message,name);
			}
		}
	}
	
	
	function idd_time(name) {
		if (!idd_isidd()) return;
		
		if (window.console && console.time !== undefined) {
			return console.time(name);
		}
	}
	
	
	function idd_timeEnd(name) {
		if (!idd_isidd()) return;
		
		if (window.console && console.time !== undefined) {
			return console.timeEnd(name);
		}
	}
	
	
	//genereert een hopelijk opvallende alert
	// de volgende alert komt iets lager maar kan onder de vorige vallen
	// IN: message - de boodschap die je af wilt beelden
	var gIddAlertYPosition = 5;
	function idd_alert(message) {
		if (!idd_isidd()) return;
		
		
		var alertbox = document.createElement('div');
		
		alertbox.style.border          = 'solid 3px red';
		alertbox.style.fontSize        = '20px';
		alertbox.style.color           = 'red';
		alertbox.style.position        = 'fixed';
		alertbox.style.top             = gIddAlertYPosition + 'px';
		alertbox.style.right           = '5px';
		alertbox.style.backgroundColor = 'white';
		alertbox.style.padding         = '5px';
		alertbox.style.zIndex          = '999';
		
		var text = document.createTextNode(message);
		alertbox.appendChild(text);
		
		document.body.insertBefore(alertbox,document.body.firstChild);
		
		//43 is 20px font + 2*5px padding plus 3px border
		gIddAlertYPosition += 43;
	}
		
	
	// om alle inputs onchange een warning te laten genereren als je de pagina verlaat zonder te submitten.
	//
	// usage: idd_addEvent(window, 'load', idd_formChangedLeavePageWarning); ergens in de initroutines
	//        skipt elements met class='noLeavePageWarning'
	//        skipt elements met name = %search%
	//        skipt elements die logisch niet iets moeten doen aan een warning
	//
	function idd_formChangedLeavePageWarning() {
		
		//http://mathiasbynens.be/notes/oninput
		
		//als er een verandering is in een input zetten we onbeforeunload van window
		//probeer original value te bewaren in origFCValue zodat we kunnen zien of iemand terugging naar origineel
		
		var selector;
		selector = "input:not(.noLeavePageWarning,"+ //alle inputs, zonder noLeavePageWarning class
		                    " .acInput,"+            // geen autocomplete inputs
		                    " [name^='search'],"+    // zonder name='search...
		                    " [name^='newselect'],"+ // zonder idd_editfield new achter SELECT* types
		                    " [type='password'],"+   // geen passwords
		                    " [type='button'],"+     // geen buttons
		                    " [type='submit'],"+     // geen submits
		                    " [type='hidden']),"+    // geen hiddens
		           " [contentEditable]"              // wel alle contenteditable
		           
		//deze selector vangt meer dan we beneden accepteren als 'moet popup genereren' omdat je per tag en per type 
		// moet bepalen wat de originele content was  (checkbox gebruikt 'checked', text gebruikt 'value', etc)
		//
		// zonder dataset.origFCValue geen popup want idd_formChangedWindowOnBeforeUnload moet origFCValue herkennen
		// EN op de correct manier afhandelen
		//
		var inputs = document.querySelectorAll(selector);
		inputs.forEach(function(e) {
			//"change" vuurt pas als je de input verlaat met je focus. dus als je iets verandert en dan
			// *gelijk* back doet dan krijg je geen popup, dus gebruik 'input' event
			if (e.type && (e.type=='checkbox' || e.type=='file' || e.type=='radio')) {
				//radio, etc. hebben geen input
				e.addEventListener('change', idd_formChangedWindowOnBeforeUnload);
				if (e.type == 'checkbox' || e.type == 'radio') {
					e.dataset.origFCValue = e.checked?'1':'0';
				} else if (e.type == 'file') {
					e.dataset.origFCValue = "";
				}
//de datepicker stopt een datum er met javascript in maar change komt ook niet langs dus never mind
//			} else if (e.type && e.type == 'text' && e.classList.contains('editfield-datepicker')) {
				
			} else {
				e.addEventListener('input', idd_formChangedWindowOnBeforeUnload);
				e.dataset.origFCValue = e.value;
			}
		});
		
		
		selector = "textarea:not(.noLeavePageWarning,"+
		                       " [name*='search'])";
		var textareas = document.querySelectorAll(selector);
		textareas.forEach(function(t) {
			t.addEventListener('input', idd_formChangedWindowOnBeforeUnload);
			t.dataset.origFCValue = t.value;
		});
		
		selector = "select:not(.noLeavePageWarning,"+
		                     " [name*='search'])";
		var selects = document.querySelectorAll(selector);
		selects.forEach(function(s) {
			s.addEventListener('change', idd_formChangedWindowOnBeforeUnload);
			s.dataset.origFCValue = s.value;
		});
		
		//en die wissen we weer als submit ingedrukt wordt zodat je niet voor elke save een popup krijgt
		
		selector = "form";
		var forms = document.querySelectorAll(selector);
		forms.forEach(function(f) {
			f.addEventListener('submit', function() { 
				//alleen wissen als *alle andere* forms geen edits hebben
				var otherFormsHaveEdits = false;
				
				forms.forEach( function(otherF) {
					// niet het submittende form
					if (otherF == f) return;
					// dit form hoeft niet meer
					if (otherFormsHaveEdits) return;
					
					Array.from(otherF.elements).forEach( function(target) {
						if (target.classList.contains('fcChanged')) otherFormsHaveEdits = true;
					});
				});
				
				if (!otherFormsHaveEdits) {
					window.removeEventListener('beforeunload', idd_formChangedReturnMessage);
				} else {
					//voorkom dat de disableSubmitTimer afgaat
					f.dataset.submitTimeout = -1;
				}
			});
		});
	}
	
	
	//eerst unbinden voor de bind zodat je niet steeds dezelfde eventhandler attached en de boel -tig keer af gaat
	function idd_formChangedWindowOnBeforeUnload(event) {
	
		//geen target set? gaat heeen
		if (event === undefined) return;
		if (event.target === undefined) return;
		
		//geen origValue set? dan doen we niet mee
		var target = event.target;
		if (target.dataset.origFCValue === undefined) {
			return;
		}
		
		//als we binnen de onload handler worden getriggerd of binnen 400ms na laden dan doen we niks
		// want het gebeurt dat in de onload een jquery click() wordt gedaan en dat is dan gelijk een form change
		// warning zonder dat de klant /iets/ doet
		// soms is er geen navigation performance entry, skip dan maar de test
		if (window.performance.getEntriesByType("navigation").length > 0) {
			if ((window.performance.now() - window.performance.getEntriesByType("navigation")[0].loadEventEnd) < 400) {
				return;
			}
		}
		
		if (idd_isidd()) {
			//probeer servicelink te vinden om te misbruiken als schakelaar
			var si = document.querySelectorAll("#iddService_icon");
			if (si.length > 0) si[0].style.backgroundColor = 'coral';
		}
		
		//verwijder eerst alles
		window.removeEventListener('beforeunload', idd_formChangedReturnMessage);
		target.classList.remove('fcChanged');
		
		//voor inputs die niet in een form zitten (wait WHAT?!)
		if (!target.form) {
			return;
		}
		
		var targetSubmits = target.form.querySelectorAll("[type='submit']");
		var allSubmits    = document.querySelectorAll("[type='submit']");
		
		//reset state
		Array.from(allSubmits).forEach( function(s) { 
			s.classList.remove('fcChanged');
			s.classList.remove('fcOtherChangedWarningForSubmit');
		});
		
		//isChanged betekent eigenlijk isChangedFromOriginalValueWhenFormLoaded
		var isChanged = false;
		
		if (target.tagName == 'INPUT') {
			if (target.type == 'checkbox') {
				isChanged = target.dataset.origFCValue != (target.checked?'1':'0');
			} else if (target.type == 'radio') {
				//voor radiobuttons moeten we /alle/ radio's checken binnen dit form met dezelfde naam en die moeten
				// allemaal dezelfde state hebben als origineel
				var otherRadios = target.form.querySelectorAll("[name='"+target.name+"']");
				Array.from(otherRadios).forEach(function(r) {
					r.classList.remove('fcChanged');
					if (r.checked != r.dataset.origFCValue) isChanged = true;
				});
			} else {
				isChanged = target.dataset.origFCValue != target.value;
			}
		} else if (target.tagName == 'TEXTAREA' || target.tagName == 'SELECT') {
			isChanged = target.dataset.origFCValue != target.value;
		}
		
		//als -ie terug is naar het origineel EN er zijn verder geen veranderde velden meer dan
		// kunnen we de beforeunload listener weg laten
		if (!isChanged && document.querySelectorAll('.fcChanged').length == 0) return;
		
		//als je hier bent zet je de eventlistener op window
		if (isChanged) {
			target.classList.add('fcChanged');
			Array.from(targetSubmits).forEach( function(s) {s.classList.add('fcChanged')});
			
			//warning op alle andere submits
			Array.from(allSubmits).forEach( function (otherSubmit) {
				if (otherSubmit.form == target.form) return;
				
				otherSubmit.classList.add('fcOtherChangedWarningForSubmit');
			});
		}
		
		window.addEventListener('beforeunload', idd_formChangedReturnMessage);
		
		if (idd_isidd()) {
			//probeer servicelink te vinden om te misbruiken als schakelaar
			si = document.querySelectorAll("#iddService_icon");
			if (si.length > 0) {
//				var perf = window.performance;
				si[0].style.backgroundColor = 'purple';
				
// 				if ((window.performance.now() - window.performance.getEntriesByType("navigation")[0].loadEventEnd) < 400) {
// 				
// 					si[0].style.backgroundColor = 'red';
// 					
// 					var div = document.createElement('DIV');
// 					div.innerHTML = "<div id='iddService_balloon'>" +
// 					                "<span>Something triggered the form changed warning on load, PLEASE FIX</span>" +
// 					                "</div>";
// 					si[0].parentNode.appendChild(div.firstChild);
//				}
			}
		}
	}
	
	
	// dus dit is de statische functie voor de waarschuwing als je een pagina verlaat zonder te saven
	function idd_formChangedReturnMessage(evt) {
		//https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
		evt.preventDefault();
		
		// Included for legacy support, e.g. Chrome/Edge < 119
		evt.returnValue = true;
		
		//alle browsers negeren meegegeven tekst
		return 'The changes you made will be lost when you navigate away from this page';
	}
	
	
	//http://maximilianhoffmann.com/posts/autoresizing-textareas
	// autoresize alle textarea's op een pagina
	// skip textareas in dbv5-html want dan heb je er zo 300+ en dan krijg je de 'deze pagina is traag' popup
	function idd_autoresizeTextareas() {
		var resizingTextareas = [].slice.call(document.querySelectorAll('textarea'));
		var dbv5Textareas     = [].slice.call(document.querySelectorAll('.dbv5-html textarea'));
		var resizeWithMouse   = false;
		
		if (!window.ResizeObserver) return; // unsupported browser
		
		// Check bij elke verandering of er een textarea is die een resize nodig heeft en voer dat vervolgens uit.
		var observer = new ResizeObserver(function(mutations) {
			if (resizeWithMouse) return;// Geen auroresize wanneer het formaat handmatig met de muis wordt aangepast.
			window.requestAnimationFrame(function() {// Voorkomt safari melding "ResizeObserver loop completed with undelivered notifications."
				mutations.forEach(function(mutation) {
					_idd_autoresizeTextarea.call(mutation.target);
				});
			});
		});
		
		//http://stackoverflow.com/a/4026828
		resizingTextareas = resizingTextareas.filter(function(number) {
			return dbv5Textareas.indexOf(number) < 0;
		});
		
		resizingTextareas.forEach(function(textarea) {
			textarea.addEventListener('input', _idd_autoresizeTextarea, false);
			
			// Alleen wanneer display mist, anders sloop je bijvoorbeeld display none textarea's
			if (!textarea.style.display) textarea.style.display = 'inline-block';// Anders staat de textarea in z'n eigen verticale space
			
			textarea.style.overflow = 'hidden';// Geen scrollbar
			
			//textarea.style.resize = 'none';// Uit want anders ontneem je de user de mogelijkheid iets te fixen
			
			textarea.onmousedown = function() { resizeWithMouse = true; }
			textarea.onmouseup = function() { resizeWithMouse = false; }
			observer.observe(textarea);// Aanroepen
		});
	}
	
	
	function idd_resizeTextarea(textarea) {
	// Ensure parameter is a valid textarea
		if (!textarea || textarea.tagName !== 'TEXTAREA') {
			console.error('idd_resizeTextarea requires a textarea element');
			return;
		}
		
		// Call the resize function with the textarea as context
		_idd_autoresizeTextarea.call(textarea);
	}

	
	
	/**
	 * Slaat alle scroll posities op van parent elementen in een array.
	 * Meestal is dat alleen een <html> element wanneer er een scrollbalk aanwezig is.
	 * Maar er wordt ook rekening gehouden met eventueel andere scrollbare parent elementen.
	 *
	 * @param {HTMLElement} el - Het element
	 * @returns array
	 */
	function getParentOverflows(el) {
		
		var arr = [];
		while (null !== (el = el.parentElement)) {
			if (el.scrollTop) {
				arr.push({
					node: el,
					scrollTop: el.scrollTop,
				});
			}
		}
		
		return arr;
	}
	
	
	//hulpfunctie
	function _idd_autoresizeTextarea() {
		
		// Vraag alle scroll posities op van parent elementen zodat we ze kunnen restoren na resizen van textarea.
		// Dit is nodig zodat we huidige scroll positie niet verliezen [cx:162691]
		var overflows = getParentOverflows(this);
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight+3)+'px'; //+3 omdat dan ook firefox alles in 1x in beeld heeft
		
		// Terugzetten van oorspronkelijke scroll posities.
		overflows.forEach(function(el) {
			el.node.scrollTop = el.scrollTop;
		});
	}
	
	
	//soms blijft de browser velden vullen, ook als dat de bedoeling niet is (edit je eigen user in CX)
	//als je nu 'autocomplete=off' zet op dat veld dan wordt dat toch een leeg veld
	function idd_killUserPassAutocomplete() {
		//password boxes
		var inputs, i;
		
		inputs = document.querySelectorAll("input[type='password'][autocomplete='off'][autocompleted]");
		for (i = inputs.length;  i--; ) {
			inputs[i].setAttribute('value','');
		}
		//alle text-inputs met username in de name
		inputs = document.querySelectorAll("input[name*='username'][type='text'][autocomplete='off'][autocompleted]");
		for (i = inputs.length;  i--; ) {
			inputs[i].setAttribute('value','');
		}
		//alle text-inputs met username in de name
		inputs = document.querySelectorAll("input[name*='login'][type='text'][autocomplete='off'][autocompleted]");
		for (i = inputs.length;  i--; ) {
			inputs[i].setAttribute('value','');
		}
	}
	
	
	//open/sluit van <li>'s met een <ul> erin
	function idd_printrhelper() {
		if (!idd_isidd()) return;
		
		var lis = document.querySelectorAll("li[data-iddprintr-string]");
		if (lis.length == 0) return;
		
		// https://developer.mozilla.org/en-US/docs/Web/CSS/list-style-type
		Array.from(lis).forEach( function(li) {
			
			li.addEventListener('click', function(e) {
				//selecteren moet nog kunnen
				if (window.getSelection().toString().length > 0) return;
				
				e.stopPropagation();
				var uls = li.querySelectorAll('ul');
				//schakelen, kleurtje is dat je makkelijk kan zien wat je dichtgeklikt hebt
				if (li.classList.contains('collapsed')) {
					Array.from(uls).forEach(function(u) { u.style.display = 'block'});
					li.classList.remove('collapsed');
					li.style.color = 'green';
				} else {
					Array.from(uls).forEach(function(u) { u.style.display = 'none'});
					li.classList.add('collapsed');
					li.style.color = 'red';
				}
				return false;
			});
		});
	}
	
	
	//PURE ASCII versie van json_stringify. in JSON mag je altijd UTF-8 sturen, en als je dat dan naar een webserver
	// stuurt die dat interpreteert als iso-8859-1 voordat je daar iets aan kan doen (PHP) heb je dubbel gezeik.
	// *deze* variant van json.stringify zorgt voor 100%, alles escapede versie van json zodat je problemen in tenminste
	// nog in PHPcode op kan lossen.
	// http://stackoverflow.com/questions/4901133/json-and-escaping-characters
	// zie cx:35652 en cx:35645 en cx:48298
	function JSON_stringify(s) {
		var json = JSON.stringify(s);
		return json.replace(/[\u007f-\uffff]/g, function(c) { 
			return '\\u'+('0000'+c.charCodeAt(0).toString(16)).slice(-4);
		});
	}


	// Zet gelinkt element op disabled als nulllabel gecheckt is.
	// We doen disabled ipv readonly omdat readonly alleen voor tekst elementen bedoeld is.
	// idd_editfield functionaliteit
	function idd_disableSiblingNullLabel() {
		document.querySelectorAll(".editfield-nullcheck").forEach(function(nullcheck) {
			//nullcheck is de checkbox
			//dit is de <input> waar de checkbox bij hoort uit idd_editfield
			var input       = document.getElementById(nullcheck.id.replace('-isnull',''));
			input.dataset.nullPreviousValue = input.value;
			
			//password heeft een -repeat veld erbij, dat moet ook meeschakelen
			var inputRepeat = document.getElementById(nullcheck.id.replace('-isnull','-repeat'));
			if (inputRepeat) inputRepeat.dataset.nullPreviousValue = inputRepeat.value;
			
			//change event
			idd_addEvent(nullcheck, 'change', function() {
				setInputDisabledState(nullcheck.checked, input);
				if (inputRepeat) setInputDisabledState(nullcheck.checked, inputRepeat);
			});
			
			enableInputOnInteraction(nullcheck, input);
			if (inputRepeat) enableInputOnInteraction(nullcheck, inputRepeat);
			
			//initiele set
			setInputDisabledState(nullcheck.checked, input);
			if (inputRepeat) setInputDisabledState(nullcheck.checked, inputRepeat);
		});
	}
	
	
	/**
	 * Set specified input field disabled state.
	 * 
	 * @param {boolean}          state
	 * @param {HTMLInputElement} input
	 */
	function setInputDisabledState(state, input) {
		input.disabled = state;
		// Input wordt opgeslagen in data attribuut en input wordt ''
		if (state) {
			/* vanwege pointer-events: revert; nodig */
			input.style.pointerEvents = 'none';
			input.dataset.nullPreviousValue = input.value;
			input.value = '';
		} else {
			// Bij het 'unchecken' van de nulllabel krijgt de input vak weer de oorspronkelijke waarde
			
			/* vanwege pointer-events: revert; nodig */
			input.style.pointerEvents = '';
			if (input.dataset.nullPreviousValue) {
				input.value = input.dataset.nullPreviousValue
				delete input.dataset.previousNullValue;
			}
		}
		
		//dit zijn alle andere elementen die je /ook/ van state wil laten wisselen, die moeten de /class/
		document.querySelectorAll("[data-isnull='" + input.name.replace('[]','') + "']").forEach(function(element) {
			element.disabled = state;
		});
	}
	
	
	/**
	 * Input element actief maken wanneer NULL label vinkje aan staat.
	 * 
	 * @param {HTMLInputElement} nullcheck
	 * @param {HTMLInputElement} input
	 */
	function enableInputOnInteraction(nullcheck, input) {
		
		/**
		 * null checkbox resetten.
		 */
		function resetNullLabel() {
			if (nullcheck.checked) {
				nullcheck.checked = false;
				setInputDisabledState(nullcheck.checked, input);
			}
		}
		
		// Bij aanpassen van het veld willen we de nullcheck automatisch uitzetten (dus niet meer disabled)
		input.addEventListener('change', resetNullLabel);
		input.addEventListener('keypress', resetNullLabel, { once: true});
		
		// Klikken op een "NULL-disabled" veld moet het veld actief maken.
		input.parentElement.addEventListener('click', function(e) {
			
			// Niets doen als nullcheck element zelf disabled is.
			if (nullcheck.readOnly || nullcheck.disabled) {
				return;
			}
			
			// Als element al enabled is hoeven we verder ook niks te doen.
			if (!input.disabled) {
				return;
			}
			
			// niet door laten bubbelen naar parents zodat er ook niet een window.onclick oid wordt uitgevoerd waardoor
			// de datepicker weer uit beeld gaat.
			e.stopPropagation();
			
			var newEvent = new MouseEvent(e.type, {
				bubbles: false, // expres niet door laten bubbelen naar parents, want dat vuurt deze onclick weer af.
				cancelable: true,
				clientX: e.clientX,
				clientY: e.clientY,
				screenX: e.screenX,
				screenY: e.screenY,
				button: e.button,
				buttons: e.buttons,
				relatedTarget: e.relatedTarget,
				view: window
			});
			
			// Originele click event doorgeven aan oorspronkelijk disabled element.
			// Dit activeert o.a. de datepicker.
			input.dispatchEvent(newEvent);
			
			setInputDisabledState(false, input);
			input.focus(); // want pointer-events stond op none (disabled)
			
			if (input.value !== '') {
				nullcheck.checked = false;
				nullcheck.dispatchEvent(new Event('change'));
			}
			
			// eenmalig blur event
			input.addEventListener('blur', function() {
				if (input.value === '' && nullcheck.checked) {
					setInputDisabledState(nullcheck.checked, input);
				}
			}, { once: true });
			
		});
	}


	/**
	 * een eenmaal gevulde file input leegmaken kan niet met browser functionaliteit dus altijd een button met
	 * clear idd_editfield type=FILE
	 */
	function idd_clearFileInputs() {
		
		//zoek alle file inputs op uit idd_editfield en hang onchange aan input type=file
		document.querySelectorAll("input[type='file'].editfield-file").forEach(function(input) {
			function enableClear() {
				document.getElementById(input.id.concat('-clear')).disabled = false;
			}
			idd_addEvent(input, 'change', enableClear);
		});
		
		//en reverse voor clear buttons
		document.querySelectorAll("input[type='button'].editfield-file-clear").forEach(function(clear) {
			function clearInput() {
				
				//verwijder de preview
				var outputDiv = document.getElementById('editfield-file-preview_' + clear.id.replace('-clear', ''));
				while (outputDiv.firstChild) {
					outputDiv.removeChild(outputDiv.lastChild);
				}
				
				//verwijder de inhoud van de <input>
				var input = document.getElementById(clear.id.replace('-clear',''));
				input.value = '';
				
				//rerun validity zodat een eventuele error gezet door idd_editfieldValidity weggaat
				input.setCustomValidity('');
				input.reportValidity();
				
				clear.disabled = true;
			}
			idd_addEvent(clear, 'click', clearInput);
		});
	}
	
	
	/**
	 * als je een image doet uploaden dan kan je een preview laten zien
	 * var op clear button
	 */
	function idd_editfieldFileUploadImagePreview() {
	
		//zoek alle file inputs op uit idd_editfield en hang onchange aan input type=file
		document.querySelectorAll("input[type='file'].editfield-file").forEach(function(input) {
			input.onchange = function(e) {
				
				var uploadId       = e.target.id;
				var outputDiv      = document.getElementById('editfield-file-preview_' + uploadId);
				var outputTemplate = document.getElementById('editfield-file-preview-template_' + uploadId);
				
				//kan span niet vinden?
				if (outputTemplate === null) return;
				if (outputDiv === null) return;
				
				//clean de oude zut
				while (outputDiv.firstChild) {
					outputDiv.removeChild(outputDiv.lastChild);
				}
				
				var filesLength = e.target.files.length;
				
				for (var i=0; i<filesLength; i++) { 
					var uploadFile  = e.target.files[i];
					var outputClone = outputTemplate.content.cloneNode(true);
					
					//hang 'm erin
					outputDiv.appendChild(outputClone);
					outputClone = outputDiv.lastChild;
					
					//hier nog de filename neerzetten, doe maar appenden aan t label
					outputClone.querySelector('label').innerText = uploadFile.name;
					
					//alleen door met plaatjes en niet door met te gek grote plaatjes (10M)
					if (uploadFile.type.split('/')[0] !== 'image' || uploadFile.size > 10e6) continue;
					
					//Standaard icon span vervangen voor preview
					var elementImg = document.createElement('img');
					elementImg.className = 'idd_file-preview-image';
					outputClone.querySelector('span').replaceWith(elementImg);
					
					//laad plaatje met filereader en zet 'm als base64 src in de DOM
					//we kunnen hier helaas nog geen block scopes gebruiken. Dus voorkom hier dat outputClone
					//wordt overschreven door volgende iteratie
					(function(output) {
						var loadImg = new FileReader();
						loadImg.onload = function() {
							//set dataurl
							output.querySelector('img').src = loadImg.result;
						};
						loadImg.readAsDataURL(uploadFile);
					})(outputClone);
					
				 }
			};
		});
	}
	

	/**
	 * 
	 */
	function idd_editfieldPassBehaviour() {
	
		//zoek alle password inputs op uit idd_editfield en hang onchange aan input
		document.querySelectorAll("input[type=checkbox].editfield-pass").forEach(function(checkbox) {
			var passwordspan = document.getElementById(checkbox.dataset.enablePassword);
			
			// Een password span heeft een copy knop waarmee wij het wachtwoord wat in de span staat kopieeren naar de
			// clipboard. Hier activeren wij de copy knop
			if (passwordspan) {
				var button = document.querySelector("button[data-pass-element='" + passwordspan.id + "']");
				button.addEventListener('click', function() {
					navigator.clipboard.writeText(passwordspan.textContent).catch(function() {
						window.alert('Unable to copy password.');
					});
				});
			}
			
			
			var baseId = checkbox.dataset.inputValue;
			var nullElement = document.getElementById(baseId + '-isnull');
			
			//als nullbox er is en je klikt m aan dan moet 'set' uit
			if (nullElement) {
				nullElement.addEventListener('click', function(e) {
					if (!e.isTrusted) return;
					
					if (nullElement.checked && checkbox.checked) checkbox.click();
				});
			}
			
			checkbox.addEventListener('change', function(e) {
				var password = this.dataset.password;
				
				var hiddenInput = document.getElementById(baseId);
				var hiddenInputRepeat = document.getElementById(baseId + '-repeat');
				
				var spanId = this.getAttribute('data-enable-password');
				
				//de tekst in de (lichtgrijze) show-password-box
				var span = document.getElementById(spanId);
				if (!span) return;
				
				
				var spanElement = span.firstChild;
				
				
				if (hiddenInput && hiddenInputRepeat && spanElement) {
					if (this.checked) {
						if (nullElement && nullElement.checked && e.isTrusted) nullElement.click();
						spanElement.style.visibility = 'visible';
						hiddenInput.value = password;
						hiddenInputRepeat.value = password;
					} else {
						spanElement.style.visibility = 'hidden';
						hiddenInput.value = '';
						hiddenInputRepeat.value = '';
					}
				}
			});
		});
	}
	
	
	/**
	 *
	 */
	function idd_editfieldNullBehaviour() {
	
		document.querySelectorAll("input[type=checkbox].editfield-nullcheck").forEach(function(checkbox) {
			
			var checkboxID  = checkbox.id;
			
			//strip "-isnull"
			var inputID     = checkboxID.substring(0, checkboxID.length - 7);
			
			var input = document.getElementById(inputID);
			if (input === null) return;
			
			//vanaf hier per editfield type bepalen wat er gebeurt
			if (input.classList.contains('editfield-datepicker')) {
				
				//right-associative: 
				// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Conditional_operator#conditional_chains
				var mode = input.classList.contains("idd-datepicker-datetime") ? "datetime":
				           input.classList.contains("idd-datepicker-date")     ? "date":
				           input.classList.contains("idd-datepicker-time")     ? "time":
				           "";
				           
				if (mode == "") return;
				
				           
				checkbox.onchange = function(e) {
					//als fcChanged dan doen we niks
					if (input.classList.contains('fcChanged')) return;
					
					//als original (input!) niet leeg is doen we ook niks
					if (input.dataset.origFCValue != "") return;
					
					//als checkbox niet gezet /was/ doen we ook niks
					if (checkbox.checked) {
						input.value = '';
						return;
					}
					
					//why the hell
					var now = new Date();
					
					var dateString = now.getFullYear() + "-" + 
					                 (now.getMonth()+1).toString().padStart(2,'0')+ "-" +
					                 now.getDate().toString().padStart(2,'0');
					                 
					var timeString = now.getHours().toString().padStart(2,'0') + ":" + 
					                 now.getMinutes().toString().padStart(2,'0');
					                
					input.value = mode == "datetime" ? dateString + " " + timeString:
					              mode == "date"     ? dateString :       timeString;
					
				};
			}
		});
	}
	
	
	/**
	 * Kruisje aan het einde van een text-input voor het leegmaken van diezelfde text-input
	 * idd_editfield
	 */
	function idd_clearTextInputs() {
		//Zoek alle .editfield-text-clear op de pagina
		document.body.querySelectorAll('.editfield-text-clear').forEach(function(clear) {
			//Leeg input en focus na een klik op het kruisje
			function clearTextInput() {
				this.previousElementSibling.value = '';
				this.previousElementSibling.focus();
			}
			idd_addEvent(clear, 'click', clearTextInput);
		});
	}
	
	
	/**
	 * PRE-submit validity checks voor elementen die dat nog niet hebben
	 * 
	 * dit /runt/ niets, dat is op basis van input en change events
	 * 
	 * idd_editfield
	 */
	function idd_editfieldValidity() {
		//type = BINHEX of elk pattern
		document.querySelectorAll("input[type='text'][pattern], input[type='tel'], input[type='url']").forEach(function(input) {
			
			//als element met laden al niet valide is dan resetten we de clientside validatie
			// helaas kan je niet per element bepalen of de validatie moet doorgaan: formnovalidate is er
			// alleen voor het hele form en niet per element
			// https://stackoverflow.com/questions/31027419/html5-novalidate-only-for-some-inputs
			if (!input.checkValidity()) {
				input.type    = 'text';
				input.removeAttribute('pattern');
				//fake met css dat de rode rand blijft staan maar dat men wel kan saven
				input.classList.add('editfield-invalid');
			}
			
			function iefCheckTextValidity(event) {
				var target     = event.target;
				var mustReport = false;
				
				//https preprenden als de klant dat niet doet want anders is het invalid. dit prepend het nu direct,
				// kan ook op onblur, maar prepend met https want dat is wat men meestal gebruikt
				// met bijhouden dat het al een keer gebeurd is want anders pest je de klant
				//
				// zo lang qSA hierboven alleen inputs heeft hoef je hier niet te checken op input
				if (target.type == 'url' && target.dataset.hasAutoScheme == undefined) {
					//niks doen met korte dingen want dan kan je nog niet zien of het "http: gaat worden
					if (target.value.length > 5) {
						if (!target.value.match(/^https?:/)) {
							target.value = 'https://' + target.value;
							target.dataset.hasAutoScheme = 1;
						}
					}
				}
				
				//reset eventuele vorige foutmelding anders blijft input.validity.customError op true en dan 
				// blijft checkValidity false teruggeven
				target.setCustomValidity('');
				// de rode lijn als het ongeldig was na load ook wissen want de :invalid neemt het over
				input.classList.remove('editfield-invalid');
				
				//pattern match?
				if (!target.checkValidity()) {
					//voorkomen dat foute waarde wordt gezet kan niet: als je hexkey aan het invoeren bent
					// is de halve invoer steeds een foute waarde (met "oneven aantal karakters" ongeldig)
					
					//validity message moet gezet door idd_editfield maar moet niet undefined zijn als die er niet is
					// (type=url, type=email)
					if (target.dataset.patternMessage != undefined) {
						target.setCustomValidity(target.dataset.patternMessage);
					}
					mustReport = true;
				}
				
				//deze moet je aanroepen anders zie je niks
				if (mustReport) target.reportValidity();
			}
			idd_addEvent(input, 'input', iefCheckTextValidity);
		});
		
		//type = FILE
		document.querySelectorAll("input[type='file'].editfield-file").forEach(function(input) {
			
			const defaultInputBackgroundColor = input.style.backgroundColor;
			//drag target stylen
			input.addEventListener('dragover', function(e) {
				this.style.backgroundColor = 'oklch(60% 0.2 150)';
			});
			
			input.addEventListener('dragleave', function(e) {
				this.style.backgroundColor = defaultInputBackgroundColor;
			});
			input.addEventListener('drop', function(e) {
				this.style.backgroundColor = defaultInputBackgroundColor;
			});


			
			function iefCheckFileValidity(event) {
				var target     = event.target;
				var files      = event.target.files;
				var mustReport = false;
				
				//reset eventuele vorige foutmelding anders blijft input.validity.customError op true en dan 
				// blijft checkValidity false teruggeven
				target.setCustomValidity('');
				
				//teveel files in de upload?
				if (files.length > target.dataset.maxFiles) {
					target.setCustomValidity("You can choose no more than " + target.dataset.maxFiles + " files here.");
					mustReport = true;
				}
				
				//te grote files in de upload?
				if (files.length > 0) {
					var totalSize = 0;
					Array.from(files).forEach(function(file) { totalSize += file.size});
					if (totalSize > target.dataset.maxSize) {
						target.setCustomValidity("Maximum upload size is " + Math.floor(target.dataset.maxSize / 1024 / 1024) + " MB.");
						mustReport = true;
					}
					
					//als image dan niet > 16k x 16k
					Array.from(files).forEach(function(file) {
						
						if (target.dataset.onlyPlainFilenames == '1') {
							if (/[^\u0000-\u00ff]/g.test(file.name)) {
								target.setCustomValidity("Please rename the file to not use special characters");
							}
						}
						
						var image = new Image();
						var reader = new FileReader();
						
						reader.onload = function(e) {
							image.src = e.target.result;
							image.onload = function() {
								if (image.width > 16000 || image.height > 16000) {
									target.setCustomValidity("Maximum pixel size is 16000 x 16000");
								}
							};
						};
						reader.readAsDataURL(file);
						
					});
					
				}
				
				//deze moet je aanroepen anders zie je niks
				if (mustReport) target.reportValidity();
			}
			idd_addEvent(input, 'input', iefCheckFileValidity);
		});
		
		//type = SELECT idd_editfield
		document.querySelectorAll('select.editfield').forEach(function(input) {
			
			// Bij inladen op rood zetten indien het al invalid is
			if (input.options[input.selectedIndex] && input.options[input.selectedIndex].getAttribute('data-invalid-option') != null) {
				input.classList.add('editfield-invalid');
				
				// Foutmeldings bericht pakken
				var message = input.getAttribute('data-invalid-message');

				input.setCustomValidity(message);
			}
			
			function iefCheckSelectValidity(event) {
				var target     = event.target;
				var mustReport = false;
				
				// Reset eventuele vorige foutmelding anders blijft input.validity.customError op true en dan 
				// blijft checkValidity false teruggeven
				target.setCustomValidity('');
				// de rode lijn als het ongeldig was na load ook wissen want de :invalid neemt het over
				target.classList.remove('editfield-invalid');
				
				// Als de optie niet gekozen kan worden
				if (target.options[target.selectedIndex].getAttribute('data-invalid-option') != null) {
					// Foutmeldings bericht pakken
					var message = target.getAttribute('data-invalid-message');
					
					target.setCustomValidity(message);
					mustReport = true;
				}
				
				//deze moet je aanroepen anders zie je niks
				if (mustReport) target.reportValidity();
			}
			idd_addEvent(input, 'change', iefCheckSelectValidity);
		});
		
		// type = RADIO
		document.querySelectorAll('span.editfield-radio').forEach(function(input) {
			var children = input.children;
			var amountOfChildren = children.length;
			var grandchild;
			// Itereren over de radio span voor de inputs
			for (var i = 0; i < amountOfChildren; i++) {
				grandchild = children[i].firstChild;
				// Negeer elementen die geen input zijn
				if (!(grandchild && grandchild.tagName == 'INPUT')) continue;
				
				// Bij inladen op rood zetten indien het al invalid is
				if (grandchild.getAttribute('data-invalid-option') != null) {
					grandchild.classList.add('editfield-invalid');
					
					// Foutmeldings bericht pakken, deze zit in de hoofd span van de radio buttons
					var message = input.getAttribute('data-invalid-message');
					
					grandchild.setCustomValidity(message);
				}
			}
			
			function iefCheckSelectValidity(event) {
				var target     = event.currentTarget;
				var mustReport = false;
				
				var children = input.children;
				var amountOfChildren = children.length;
				var grandchild;
				// Itereren over de radio span voor de inputs
				for (var i = 0; i < amountOfChildren; i++) {
					grandchild = children[i].firstChild;
					// Negeer elementen die geen input zijn
					if (!(grandchild && grandchild.tagName == 'INPUT')) continue;
					
					// Reset eventuele vorige foutmelding anders blijft input.validity.customError op true en dan 
					// blijft checkValidity false teruggeven
					grandchild.setCustomValidity('');
					// de rode lijn als het ongeldig was na load ook wissen want de :invalid neemt het over
					grandchild.classList.remove('editfield-invalid');
					
					// Als de optie niet gekozen kan worden
					if (grandchild.checked && grandchild.getAttribute('data-invalid-option') != null) {
						// Foutmeldings bericht pakken, deze zit in de hoofd span van de radio buttons
						var message = target.getAttribute('data-invalid-message');
						
						grandchild.setCustomValidity(message);
						mustReport = true;
					}
					
					//deze moet je aanroepen anders zie je niks
					if (mustReport) grandchild.reportValidity();
				}
			}
			idd_addEvent(input, 'change', iefCheckSelectValidity);
		});
	}
	
	/**
	 * gebeurt te vaak dat mensen twee keer op save klikken, zet een 30 sec timeout op re-submit
	 */
	function idd_disableSubmitAfterSubmit() {
		var forms = document.querySelectorAll('form');
		
		Array.from(forms).forEach(function(form) {
			if (form.id == 'securityLoginForm') return;
			
			form.addEventListener('submit', function(event) {
				//alle allSubmits disablen zodat ze niet uit wacht-ongeduld op andere knoppen gaan klikken
				// en POST data kwijtraken
				var allSubmits   = document.querySelectorAll("input[type='submit']");
				var submitter = event.submitter;
				
				//disable alle submits
				Array.from(allSubmits).forEach( function(submit) {
					//pas op: disabled wordt een string
					submit.dataset.submitWasDisabled = submit.disabled;
					submit.dataset.submitOldValue    = submit.value;
					
					submit.disabled = true;
				});
				
				//<input type=hidden> kopie maken van de submitter want een disabled input post niet en dan 
				// weet je niet welke button submitted werd
				//submitter kan null zijn als je submit met enter
				if (submitter !== null) {
					var clone = submitter.cloneNode();
					if (clone.id) clone.id = 'clone_' + clone.id;
					clone.type = 'hidden';
					clone.disabled = false;
					//die hangen we erVOOR zodat de submit input wint
					submitter.parentNode.insertBefore(clone, submitter);
				}
				
				
				//teller in de button. kan niet de tekst aanpassen want die is steeds anders, niet altijd
				// 'save' ("send mailing" etc)
				var submitTimeout = 30;
				// formChangedLeavePageWarning zou hier de timer gedisabled kunnen hebben
				// als we voorbij deze test zijn als submitTimeout gereset wordt is niet erg want
				// in de timer loop checken we op <= 0
				if (form.dataset.submitTimeout < 0) {
					//opruimen
					delete form.dataset.submitTimeout;
					
					//alleen de niet-disabled buttons weer aanzetten + tekst terug
					Array.from(allSubmits).forEach( function(submit) {
						//datasets zijn altijd string dus vergelijk met string
						if (submit.dataset.submitWasDisabled != 'true') {
							submit.disabled = false;
						}
					});
					
					return;
				}
				
				form.dataset.submitTimeout = submitTimeout;
				var timer = setInterval( function() {
				
					//dit cast string naar int en weer terug
					form.dataset.submitTimeout--;
					
					//drie sec delay voordat de teller in beeld komt: daardoor zie je als gebruiker direct
					// dat je ook echt raak geklikt hebt
					if (submitter !== null && form.dataset.submitTimeout < submitTimeout - 2) {
						submitter.value = submitter.dataset.submitOldValue + " (" + form.dataset.submitTimeout + ")...";
					}
					
					if (form.dataset.submitTimeout <= 0) {
						clearInterval(timer);
						delete form.dataset.submitTimeout;
						
						//alleen de niet-disabled buttons weer aanzetten + tekst terug
						Array.from(allSubmits).forEach( function(submit) {
							//datasets zijn altijd string dus vergelijk met string
							if (submit.dataset.submitWasDisabled != 'true') {
								submit.disabled = false;
							}
							submit.value    = submit.dataset.submitOldValue;
						});
						
						//zonder submitter geen clone
						if (typeof clone !== 'undefined') clone.remove();
						
					}
				}, 1000);
			});
		});
	}
	
	// verberg eventuele idd notifications
	function idd_hideIddNotification() {
		var notifications = document.querySelectorAll('.idd_banner');
		
		Array.from(notifications).forEach( function(noti) {
			var notiID = noti.dataset.notificationId;
			
			noti.addEventListener('click', function() {
				// hide een week
				document.cookie = "hide_idd_notification=" + notiID + ";max-age=1814400;path=/";
				noti.style.display = 'none';
			});
		});
	}
	
	function idd_modifyConsole() {
		/* dumpt unicode codepoints als hex comma-separated string als dat gaat voor meegegeven parameter */
		console.dumpCodePoints = function(string) {
			if (typeof string !== 'string') {
				if (typeof string.toString == 'undefined') {
					console.trace('cannot dump codepoints')
				} else {
					string = string.toString();
				}
			}
			
			var codePoints = [];
			Array.from(string).forEach(function(element) {
				var codePoint = element.codePointAt(0);
				codePoints.push(codePoint.toString(16));
			});
			console.log(codePoints.join(','));
		};
	}
	
	
	
	
	//default idd functionaliteit
	idd_addEvent(window,'load',idd_killUserPassAutocomplete);
	idd_addEvent(window,'load',idd_printrhelper);
	idd_addEvent(window,'load',idd_makePasswordToggle);
	idd_addEvent(window,'load',idd_debugHideShow);
	idd_addEvent(window,'load',idd_disableSiblingNullLabel);
	idd_addEvent(window,'load',idd_autoresizeTextareas);
	idd_addEvent(window,'load',idd_formChangedLeavePageWarning);
	idd_addEvent(window,'load',idd_prevent_enter_submit);
	idd_addEvent(window,'load',idd_clearFileInputs);
	idd_addEvent(window,'load',idd_clearTextInputs);
	idd_addEvent(window,'load',idd_editfieldValidity);
	idd_addEvent(window,'load',idd_editfieldFileUploadImagePreview);
	idd_addEvent(window,'load',idd_editfieldNullBehaviour);
	idd_addEvent(window,'load',idd_editfieldPassBehaviour);
	idd_addEvent(window,'load',idd_disableSubmitAfterSubmit);
	idd_addEvent(window,'load',idd_hideIddNotification);
	idd_addEvent(window,'DOMContentLoaded',idd_modifyConsole);
	
	
	
	// ============================================================================
	// Beautify SQL and Trace Renderbox
	// ============================================================================
	document.addEventListener('DOMContentLoaded', function() {
	
		// Add border and mousehover css
		var queryselector = document.querySelectorAll('.debug.renderbox.query');
		
		// Check clicks for every query renderbox
		var qlen = queryselector.length;
		for (var i = 0; i < qlen; i++) {
			var q = queryselector[i];
			
			q.style.borderLeftWidth = '2px';
			q.style.cursor          = 'pointer';
			
			// Check if clicked and not dragged
			var mouseMoved = false;
			q.addEventListener("mousedown", function() {
				mouseMoved = false;
			});
			q.addEventListener("mousemove",  function() {
				mouseMoved = true;
			});
			q.addEventListener("mouseup",  function() {
				if (mouseMoved) return;
				runBeautifySQL(this);
			});
		}
		
		// Switch between beautify and ugly 
		// Only act when clicked, not dragged
		function runBeautifySQL(q) {
			var text = q.textContent;
			
			// Add data attribute to toggle between beautify and ugly
			if (q.dataset.queryexpand == 1) {
				q.innerHTML = q.save_text;
				q.dataset.queryexpand = 0;
				return;
			} else {
				q.dataset.queryexpand = 1;
				q.save_text = text;
			}
		
			// Title is 'DB::1234::Q1'
			var title = text.substr(0, text.indexOf(" "));
			// Text is an array of the query and trace
			text  = text.substr(text.indexOf(" ") + 1).split("-- ");
			var query = text[0];
			var trace = text[1];

			// This is where the magic happens
			var beautify_query = beautifySQL(query);
		
			// ===================================
			// Append the HTML code into the DIV =
			// ===================================
			q.innerHTML = '';
			q.innerHTML += title;
		
			// -----------------
			// Beautified query
			// -----------------
			q.innerHTML += "<br><pre>"+beautify_query+"</pre>";
		
			// -----------------
			// Trace table
			// -----------------
			var result = trace.split(/f\d+:/g);
			var html = '';
			html += '<table style="width: auto; border: solid 1px;border-collapse: collapse; margin: 3px 0;">';
			var style = 'style="color:black;background-color:white;font-size:8pt;'+
					'padding:2px;border:solid 1px black;text-align:left"';
			// THead
			html += '<thead>';
			html += '<tr>';
			html += '<th '+style+'>file</th>';
			html += '<th '+style+'>line</th>';
			html += '<th '+style+'>function</th>';
			html += '</tr>';
			html += '</thead>';
		
			// TBody
			html += '<tbody>';
		
			var traceLength = result.length;
			for (var i=0; i < traceLength; i++) {
			
				var arr = result[i].split("/");
			
				var file   = "";
				var line   = "";
				var func   = "";
			
				file = arr[0];
				if (file == '') {
					continue;
				}
				if (arr.length > 1) {
					line   = arr[1].split(":")[1];
				}
				if (arr.length > 2) {
					func   = arr[2].split(":")[1];
				}
			
				html += '<tr>';
				html += '<td '+style+'>'+file+'</td>';
				html += '<td '+style+'>'+line+'</td>';
				html += '<td '+style+'>'+func+'</td>';
				html += '</tr>';
			}
			html += '</tbody>';
			html += '</table>';
			q.innerHTML += html;
		}
		
	});

	// Beautify the SQL query
	// IN:  text - query text
	// UIT: beautified SQL query
	function beautifySQL(text) {

		// Used variables
		var ar_by_quote  = text.replace(/\s{1,}/g," ").split('~::~');
		var len          = ar_by_quote.length;
		var ar           = [];
		var tab          = '   ';
		var str          = '';
	
		// Split the queries on keywords
		for (var ix=0;ix<len;ix++) {
			ar = ar.concat(_beautifySplitSQL(ar_by_quote[ix], tab) );
		}
	
		// Beautify enumerations
		len = ar.length;
		for (ix=0;ix<len;ix++) {
			// Make the `column1`, `column2` below each other
			if( /\s{0,}\s{0,}SELECT\s{0,}/.exec(ar[ix]))  {
				ar[ix] = ar[ix].replace(/,/g,",\n"+tab+"  ")
			}
		
			// Make the `column1`, `column2` below each other
			if( /\s{0,}(VALUES\s*(\S+)\s*)\s{0,}/.exec(ar[ix]))  {
					ar[ix] = ar[ix].replace(/,/g,",\n"+tab+"  ")
			}
		
			// Make the `column1`, `column2` below each other
			if( /\s{0,}\s{0,}SET\s{0,}/.exec(ar[ix]))  {
				ar[ix] = ar[ix].replace(/,/g,"\n"+tab)
			}
		}
		// Separate every line with a linebreak
		str = ar.join("\n");
		str = str.replace(/^\n{1,}/,'').replace(/\n{1,}/g,"\n");
		return str;
	}


	// Split the SQL query by keywords
	// IN:  str - the query string
	//      tab - tab preset
	// UIT: the query splitted by keywords
	function _beautifySplitSQL(str, tab) {

		var out = str.replace(/\s{1,}/g," ")
				   
				  .replace(/ AND /ig,"~::~"+tab+tab+"AND ")
				  .replace(/ BETWEEN /ig,"~::~"+tab+"BETWEEN ")
				  .replace(/ CASE /ig,"~::~"+tab+"CASE ")
				  .replace(/ ELSE /ig,"~::~"+tab+"ELSE ")
				  .replace(/ END /ig,"~::~"+tab+"END ")
				  .replace(/ FROM /ig,"~::~FROM ")
				  .replace(/ GROUP\s{1,}BY/ig,"~::~GROUP BY ")
				  .replace(/ HAVING /ig,"~::~HAVING ")
				  .replace(/ IN /ig," IN ")
				  
				  .replace(/ JOIN /ig,"~::~JOIN ")
				  .replace(/ CROSS~::~{1,}JOIN /ig,"~::~CROSS JOIN ")
				  .replace(/ INNER~::~{1,}JOIN /ig,"~::~INNER JOIN ")
				  .replace(/ LEFT~::~{1,}JOIN /ig,"~::~LEFT JOIN ")
				  .replace(/ RIGHT~::~{1,}JOIN /ig,"~::~RIGHT JOIN ")
				  
				  .replace(/ ON /ig,"~::~"+tab+"ON ")
				  .replace(/ OR /ig,"~::~"+tab+tab+"OR ")
				  .replace(/ ORDER\s{1,}BY/ig,"~::~ORDER BY ")
				  .replace(/ OVER /ig,"~::~"+tab+"OVER ")
				  
				  .replace(/\(\s{0,}SELECT /ig,"~::~(SELECT ")
				  .replace(/\)\s{0,}SELECT /ig,")~::~SELECT ")
				  
				  .replace(/\(\s{0,}INSERT INTO/ig,"~::~(INSERT INTO")
				  .replace(/\)\s{0,}INSERT INTO/ig,")~::~INSERT INTO")
				  
				  .replace(/ THEN /ig," THEN~::~"+tab+"")
				  .replace(/ UNION /ig,"~::~UNION~::~")
				  .replace(/ USING /ig,"~::~USING ")
				  .replace(/ WHEN /ig,"~::~"+tab+"WHEN ")
				  .replace(/ WHERE /ig,"~::~WHERE ")
				  .replace(/ WITH /ig,"~::~WITH ")
				  
				  .replace(/ ALL /ig," ALL ")
				  .replace(/ AS /ig," AS ")
				  .replace(/ ASC /ig," ASC ")
				  .replace(/ DESC /ig," DESC ")
				  .replace(/ DISTINCT /ig," DISTINCT ")
				  .replace(/ EXISTS /ig," EXISTS ")
				  .replace(/ NOT /ig," NOT ")
				  .replace(/ NULL /ig," NULL ")
				  .replace(/ LIKE /ig," LIKE ")
				  .replace(/\s{0,}SELECT /ig,"SELECT ")
				  
				  .replace(/\s{0,}INSERT INTO /ig,"INSERT INTO ")
				  .replace(/\s{0,}(INSERT INTO(.*?)`(\S+))/ig,"$1 \n")
				  .replace(/\s{0,}(UPDATE(.*?)`(\S+))/ig,"$1 \n")
				  .replace(/VALUES /ig,"~::~VALUES ")
				  
				  .replace(/(~::~){1,}/g,"~::~")
				  .split('~::~');
		
		//extra spatie aan het begin voor elk open haakje
		var indent = 0;
		var len = out.length;
		for (var i = 0; i < len; i++) {
			out[i] = Array(indent).join(tab) + out[i];
			
			//tel aantal ( en voeg spatie aan begin toe
			indent += out[i].split('(').length - 1;
			indent -= out[i].split(')').length - 1;
		}
		
		return out;
		
	}
	// ============================================================================
	// End of Beautify SQL and Trace
	// ============================================================================
	
	
	/**
	 * autocompleted attribuut op element zetten als browser input vult 
	 * 
	 * hoort ook wat CSS uit czz/common.css bij
	 *
	 * https://github.com/matteobad/detect-autofill/blob/master/src/detect-autofill.js
	 */
	
	document.addEventListener('animationstart', onAnimationStart, true);
	document.addEventListener('input', onInput, true);
	
	/**
	 * Handler for -webkit based browser that listen for a custom
	 * animation create using the :pseudo-selector in the stylesheet.
	 * Works with Chrome, Safari
	 *
	 * @param {AnimationEvent} event
	 */
	function onAnimationStart(event) {
		('onautofillstart' === event.animationName) ?
		   autocomplete(event.target) :
		   cancelAutocomplete(event.target);
	}
	
	
	/**
	 * Handler for non-webkit based browser that listen for input
	 * event to trigger the autocomplete-cancel process.
	 * Works with Firefox, Edge, IE11
	 *
	 * @param {InputEvent} event
	 */
	function onInput(event) {
		('insertReplacementText' === event.inputType || !('data' in event)) ?
		   autocomplete(event.target) :
		   cancelAutocomplete(event.target);
	}
	
	
	/**
	 * Manage an input element when its value is autocompleted
	 * by the browser in the following steps:
	 * - add [autocompleted] attribute from event.target
	 * - create 'onautocomplete' cancelable CustomEvent
	 * - dispatch the Event
	 *
	 * @param {HTMLInputElement} element
	 */
	function autocomplete(element) {
		if (element.hasAttribute('autocompleted')) return;
		element.setAttribute('autocompleted', '');
		
		var event = new window.CustomEvent('onautocomplete', {
			bubbles: true, cancelable: true, detail: null,
		});
		
		// no autofill if preventDefault is called
		if (!element.dispatchEvent(event)) {
			element.value = '';
		}
	}
	
	/**
	 * Manage an input element when its autocompleted value is
	 * removed by the browser in the following steps:
	 * - remove [autocompleted] attribute from event.target
	 * - create 'onautocomplete' non-cancelable CustomEvent
	 * - dispatch the Event
	 *
	 * @param {HTMLInputElement} element
	 */
	function cancelAutocomplete(element) {
		if (!element.hasAttribute('autocompleted')) return;
		element.removeAttribute('autocompleted');
		
		// dispatch event
		element.dispatchEvent(new window.CustomEvent('onautocomplete', {
			bubbles: true, cancelable: false, detail: null,
		}));
	}
	
	/*
	 * tot hier
	 */
	 
	return {
		addEvent: idd_addEvent,
		uriRoot: idd_uriRoot,
		origin: idd_origin,
		assert: idd_assert,
		escapeHTML: idd_escapeHTML,
		htmlEntityDecode: idd_htmlEntityDecode,
		isidd: idd_isidd,
		printR: idd_print_r,
		time: idd_time,
		timeEnd: idd_timeEnd,
		alertBox: idd_alert,
		formChangedLeavePageWarning: idd_formChangedLeavePageWarning,
		idd_formChangedWindowOnBeforeUnload: idd_formChangedWindowOnBeforeUnload,
		idd_formChangedReturnMessage: idd_formChangedReturnMessage,
		autoresizeTextareas: idd_autoresizeTextareas,
		resizeTextarea: idd_resizeTextarea,
		killUserPassAutocomplete: idd_killUserPassAutocomplete,
		jsonStringify: JSON_stringify,
		makePasswordToggle: idd_makePasswordToggle,
		debugHideShow: idd_debugHideShow,
		disableSiblingNullLabel: idd_disableSiblingNullLabel,
		prevent_enter_submit: idd_prevent_enter_submit
	};
});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
